import { styled } from 'styled-components';

export const BackImageBox = styled.img`
    position: absolute;
    image-rendering: pixelated;
    image-rendering: -moz-crisp-edges;
    image-rendering: crisp-edges;
    width: 320px;
    top: -37px
`;
